export class MechanicalOrder {
}
//# sourceMappingURL=mechanical-order.js.map